import React from "react";
import "./Surrounding.scss";
import aeon from "../../Media/Surrounding HI/John Paul.webp";
import prasmul from "../../Media/Surrounding HI/Courts.webp";
import binus from "../../Media/Surrounding HI/Eka Hospital.webp";
import breeze from "../../Media/Surrounding HI/Living Plaza.webp";
import qbig from "../../Media/Surrounding HI/Sekolah Penabur.webp";
import eka from "../../Media/Surrounding HI/Universitas Esa Unggul.webp";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
const Surrounding = () => {
  const slides = [
    {src: aeon, des: "John Paul's School"},
    {src: prasmul, des: "Courts"},
    {src: binus, des: "Eka Hospital"},
    {src: breeze, des: "Living Plaza"},
    {src: qbig, des: "BPK Penabur School"},
    {src: eka, des: "Esa Unggul University"},
  ];
  const settings = {
    dots: true,
    infinite: true,
    autoplay: false,
    lazyLoad: true,
    speed: 500,
    autoplaySpeed: 2000,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  return (
    <div id="surrounding" className="surroundingcontainer">
      <div className="title">SURROUNDING AREA</div>
      <div className="content">
        {slides.map((slide, index) => (
          <div className="center" key={index}>
            <img className="imgcontent" src={slide.src} alt="Surrounding" />
            <div className="imgdes">
              <span>{slide.des}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="content1">
        <Slider {...settings}>
          {slides.map((slide, index) => (
            <div className="center" key={index}>
              <img className="imgcontent" src={slide.src} alt="Surrounding" />
              <div className="imgdes">
                <span>{slide.des}</span>
              </div>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default Surrounding;
